// extracted by mini-css-extract-plugin
module.exports = {"summaryBox":"MeInANutshell-module--summaryBox--3A9gM","summaryText":"MeInANutshell-module--summaryText--TnWW0","summaryPitch":"MeInANutshell-module--summaryPitch--ZUYmf"};